import { NgClass } from '@angular/common';
import { Component, Input, output } from '@angular/core';

import { TellentBrand } from '@tellent/types';

import { TranslatePipe } from '@recruitee/i18n';
import type { ArrowPosition } from '@recruitee/user-interface';
import {
  BadgeComponent,
  BaseTooltipComponent,
  ButtonComponent,
  IconButtonComponent,
  PreventOrphansPipe,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.less'],
  imports: [
    NgClass,
    BadgeComponent,
    IconButtonComponent,
    ButtonComponent,
    TranslatePipe,
    PreventOrphansPipe,
  ],
  host: {
    '[class]': 'brand',
  },
})
export class FeatureTooltipComponent extends BaseTooltipComponent {
  public readonly TellentBrand = TellentBrand;

  @Input() public isNew: boolean;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public ctaText?: string;
  @Input() public learnMore?: string;
  @Input() public learnMoreCopy?: string;
  @Input() public arrowPosition: ArrowPosition;
  @Input() public brand?: TellentBrand = TellentBrand.Recruitee;

  public learnMoreClick = output<void>();
  public ctaClick = output<void>();
  public close = output<void>();

  public ngOnChanges(): void {
    this.updateArrow(this.arrowPosition);
  }
}
